import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

import Home from "@/pages/Home";
import OrderForm from "@/pages/OrderForm";
import OrderConfirmation from "@/pages/OrderConfirmation";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import MyOrders from "@/pages/MyOrders";
import Admin from "@/pages/Admin";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Coverage from "@/pages/Coverage";

function Shell({ children }) {
    return (
        <div className="App flex flex-col min-h-screen">
            <Navbar />
            <main className="flex-1">{children}</main>
            <Footer />
            <FloatingWhatsApp />
        </div>
    );
}

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster position="top-right" richColors />
                <Routes>
                    <Route path="/" element={<Shell><Home /></Shell>} />
                    <Route path="/order" element={<Shell><OrderForm /></Shell>} />
                    <Route path="/order-confirmation/:orderNumber" element={<Shell><OrderConfirmation /></Shell>} />
                    <Route path="/login" element={<Shell><Login /></Shell>} />
                    <Route path="/register" element={<Shell><Register /></Shell>} />
                    <Route path="/about" element={<Shell><About /></Shell>} />
                    <Route path="/contact" element={<Shell><Contact /></Shell>} />
                    <Route path="/coverage" element={<Shell><Coverage /></Shell>} />
                    <Route
                        path="/my-orders"
                        element={
                            <ProtectedRoute>
                                <Shell><MyOrders /></Shell>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin"
                        element={
                            <ProtectedRoute adminOnly>
                                <Admin />
                            </ProtectedRoute>
                        }
                    />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}
